// eslint-disable-next-line import/prefer-default-export
export const ManagerApprovalAction = Object.freeze({
    Approve: 0,
    Refuse: 1,
});
